import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import useUiToasts from '../../stores/ToastStore';

function Toasts() {
    const [uiToastState, uiToastActions] = useUiToasts();
    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();

    // Watch for current alert changes.
    useEffect(() => {
        if (_.isEmpty(uiToastState.text) || uiToastState.createOnNavigate) {
            return;
        }

        enqueueSnackbar(uiToastState.text);

        // can't watch and set uiToastActions
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uiToastState, enqueueSnackbar, uiToastActions]);

    // Listening to navigation changes, we'll clear the alert when this happens.
    useEffect(() => {
        uiToastActions.queueDelayedToast();
        // can't watch and set uiToastActions
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return null;
}

export default Toasts;
